<template>
    <div :class="{'io-base-table': true, vertical}" :style="styles">
        <template v-for="(field, col) in fields">
            <div
                :class="{'io-base-table--data io-base-table--head': true, 'colored': vertical ? rowHighlight(col) : false}"
                :data-row="vertical ? col + 1 : 1"
                :style="{'grid-column': vertical ? 1 : col + 1, 'grid-row': vertical ? col + 1 : 1}"
                :key="field.key"
            >
                <span>{{ field.label }}</span>
            </div>
            <div
                :class="{'io-base-table--data': true, 'colored': vertical ? rowHighlight(col) : true}"
                :data-row="vertical ? col + 1 : row + 2"
                :style="{'grid-column': vertical ? row + 2 : col + 1, 'grid-row': vertical ? col + 1 : row + 2}"
                v-for="(item, row) in getItems()"
                :key="field.key + item.id"
            >
                <span>{{ item[field.key] }}</span>
            </div>
        </template>
    </div>
</template>

<script>
export default {
  name: 'IoBaseTable',
  props: {
    fields: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      default: () => ([]),
    },
    endpoint: {
      type: String,
      default: '',
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    shrinkFirst: {
      type: Boolean,
      default: false,
    },
    shrinkLast: {
      type: Boolean,
      default: false,
    },
    highlight: {
      type: String,
      validator: (val) => ['odd', 'even'].indexOf(val) !== -1,
      default: 'odd',
    },
  },
  computed: {
    columCount() {
      return this.vertical
        ? this.items.length - 1
        : this.fields.length - 2;
    },
    styles() {
      return {
        '--column-count': this.columCount,
        '--column-first-width': this.shrinkFirst ? 'min-content' : '1fr',
        '--column-last-width': this.shrinkLast ? 'min-content' : '1fr',
      };
    },
  },
  methods: {
    getItems() {
      const { items } = this;
      // axios.get(this.endpoint).then(({ data }) => {
      //     items = data.items
      // })
      return items;
    },
    rowHighlight(val) {
      return this.highlight === 'odd' ? (val + 1) % 2 !== 0 : (val + 1) % 2 == 0;
    },
  },
};
</script>

<style lang="scss" scoped>
    .io-base-table {
        width: 100%;
        display: grid;
        grid-template-columns: var(--column-first-width) repeat(var(--column-count), 1fr) var(--column-last-width);
        grid-template-rows: auto;
        grid-row-gap: 1rem;
        overflow: scroll;

        &--data {
            padding: 0 1rem;

            &:not([data-row="1"]) {
                padding: 1rem;
            }

            &.colored {
                background-color: #F2F2F2;
            }
        }

        &--head {
            font-weight: 700;
        }

        &.vertical.io-base-table {
            grid-row-gap: 0;

            .io-base-table--data {
                padding: 1rem;
            }
        }
    }
</style>

<style lang="scss" scoped>

</style>
